import {
	Dialog,
	DialogContent,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from '@/common/ui/dialog'
import { Button } from '@/common/ui/button'
import { ScrollArea } from '@/common/ui/scroll-area'
import { Form } from '@/common/ui/form'
import { useItemForm } from './hooks'
import {
	ItemTypeField,
	BasicFields,
	ImageUploadField,
	EligibilityField,
	MinValueField,
	ConditionalFields,
} from './components'
import { TYPES_REQUIRING_MIN_VALUE } from './constants'
import type { NotificationItemFormData } from './types'

export type { NotificationItemFormData }

interface BrokeFlexMessageItemEditModalProps {
	open: boolean
	onClose: () => void
	itemIndex: number
	isAddingNew: boolean
	currentItem?: NotificationItemFormData
	onSave: (itemData: NotificationItemFormData) => void
}

export default function BrokeFlexMessageItemEditModal({
	open,
	onClose,
	itemIndex,
	isAddingNew,
	currentItem,
	onSave,
}: BrokeFlexMessageItemEditModalProps) {
	const { form, selectedType } = useItemForm({
		isAddingNew,
		itemIndex,
		currentItem,
	})

	const handleSave = (data: NotificationItemFormData) => {
		onSave(data)
	}

	const handleImageUploaded = (fileUrl: string) => {
		form.setValue('imageUrl', fileUrl)
	}

	return (
		<Dialog open={open} onOpenChange={onClose}>
			<DialogContent className="max-w-2xl">
				<DialogHeader>
					<DialogTitle>
						{isAddingNew ? 'เพิ่มรายการใหม่' : 'แก้ไขรายการ'}
					</DialogTitle>
				</DialogHeader>

				<ScrollArea className="max-h-[60vh] pr-4">
					<Form {...form}>
						<form
							onSubmit={form.handleSubmit(handleSave)}
							className="space-y-4"
						>
							<ItemTypeField control={form.control} />

							<BasicFields control={form.control} />

							<ImageUploadField
								control={form.control}
								onImageUploaded={handleImageUploaded}
							/>

							<EligibilityField control={form.control} />

							{selectedType &&
								TYPES_REQUIRING_MIN_VALUE.includes(selectedType) && (
									<MinValueField control={form.control} watch={form.watch} />
								)}

							<ConditionalFields
								control={form.control}
								selectedType={selectedType}
							/>
						</form>
					</Form>
				</ScrollArea>

				<DialogFooter>
					<Button type="button" variant="outline" onClick={onClose}>
						ยกเลิก
					</Button>
					<Button type="button" onClick={form.handleSubmit(handleSave)}>
						{isAddingNew ? 'เพิ่ม' : 'บันทึก'}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}
